var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.345,
    height: 70.787,
    viewBox: "0 0 68.345 70.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-paperclip",
    "data-name": "Icon feather-paperclip",
    d: "M64.1,32.454,35.217,61.342A18.871,18.871,0,0,1,8.53,34.654L37.417,5.766A12.581,12.581,0,0,1,55.209,23.558L26.29,52.446a6.29,6.29,0,1,1-8.9-8.9L44.081,16.894",
    transform: "translate(-0.003 0.918)",
    fill: "none",
    stroke: "#e61f2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.37e108ca.svg";
export { ForwardRef as ReactComponent };